export default () => {
  const packshotVisibleClassNameHide = 'product-card__packshot--hide';
  const productListRootSelector = '[data-product-list]';
  const productListItemSelector = '[data-product-list-observer]'
  const productListRoot = document.querySelector(productListRootSelector);
  const productListItemArray = productListRoot.querySelectorAll(productListItemSelector);

  /**
   * Intersection Observer setup
   */
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.33,
  };
  const observerCallback = (entries) => {

    // entries.forEach((entry) => {
    //   if (entry.intersectionRatio > 0.33) {
    //     entry.target.classList.remove(packshotVisibleClassNameHide);
    //     //observer.unobserve(entry.target);
    //   } else {
    //     entry.target.classList.add(packshotVisibleClassNameHide);
    //   }
    // });

    for(let i=0; i<entries.length; i++) {
      if (entries[i].intersectionRatio > 0.33) {
        entries[i].target.classList.remove(packshotVisibleClassNameHide);
        //observer.unobserve(entries[i].target);
      } else {
        entries[i].target.classList.add(packshotVisibleClassNameHide);
      }
    }
  };
  const intersectionObserver = new IntersectionObserver(observerCallback, observerOptions);

  /**
   * Hide elements on start
   */
  // productListItemArray.forEach((element) => {
  //   element.classList.add(packshotVisibleClassNameHide);
  //   intersectionObserver.observe(element);
  // });

  for (let i=0; i<productListItemArray.length; i++) {
    productListItemArray[i].classList.add(packshotVisibleClassNameHide);
    intersectionObserver.observe(productListItemArray[i]);
  }
};